import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_OrderGroup } from '@app/pathway-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
export const dispatch_onOrderGroupsUpdated = new ThunderDispatcherV3('__onOrderGroupsUpdated');
export class ModuleFE_OrderGroup_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_OrderGroup, dispatch_onOrderGroupsUpdated);
        this._v1 = {};
    }
    // ######################## Search ########################
    __searchFilterMapper = (item) => [item.name, item._id];
    __searchGroups = (items, filter) => {
        return [{
                group: this.dbDef.entityName,
                results: items.map(item => ({ _id: item._id, uiLabel: item.name }))
            }];
    };
}
export const ModuleFE_OrderGroup = new ModuleFE_OrderGroup_Class();
//# sourceMappingURL=ModuleFE_OrderGroup.js.map